import { Lightning as lng } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';

const Constants = {
  defaultBgColor: Theme.Colors.CmsProgress.Unfilled,
  defaultFillColor: Theme.Colors.Primary,
  defaultHeight: 8,
};

export class ProgressBar extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      Background: {
        rect: true,
        w: w => w,
        h: h => h,
        color: this.bindProp('bgColor'),
      },
      Fill: {
        rect: true,
        w: this.bindProp('fillPercentage', ctx => Math.min(ctx.fillPercentage, 1) * ctx.finalW),
        h: h => h,
        color: this.bindProp('fillColor'),
      },
    };
  }

  _build() {
    this.fillPercentage = 0;
    this.bgColor = Constants.defaultBgColor;
    this.fillColor = Constants.defaultFillColor;
  }
}
